// extracted by mini-css-extract-plugin
export default {"base":"ColumnChartDisplay_base__42D7k","select":"ColumnChartDisplay_select__7fwlc"};